import http from "../../utils/http";
import { toast } from "../../utils/toast";
// 회사에서 사용중인 카드 목록조회
export const getCardsList = () => {
  return new Promise((resolve, reject) => {
    http
      .post("/cards/list")
      .then((res) => {
        // toast.success('신용카드 목록이 조회되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 모든 신용카드 요약정보 리스트
export const getCardsTypesPurchaseSummaries = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/cards/types/purchase/summaries", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 모든 신용카드 요약정보 리스트 :: 직원에게 할당된 카드 경비청구 시 사용 됨 
export const getCardsEmployeeList = (employeeIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/cards/employees/${employeeIdx}/list`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 모든 신용카드 매입내역 리스트 조회
export const getCardRecordsPurchaseList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/purchase/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 특정카드 매입내역 리스트 조회
export const getCardRecordsCardsPurchaseList = (cardIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/card-records/purchase/cards/${cardIdx}/list`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 카드 매입 목록
export const getCardsPurchases = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/cards/purchases")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 카드 매입 상세 내역
export const getCardsPurchasesDetail = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/cards/purchases/details")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 카드별 묶음 매입목록
export const getCardsPurchasesGroup = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/purchases/groups/cards", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 매입내역 수정
export const updateCardsPurchases = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/cards/purchases/${idx}`, body)
      .then((res) => {
        toast.success("카드 매입 내역이 수정되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 등록할 매입내역에 청구내역 등록
export const createCardsExpense = (expenseIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/cards/purchases/expenses/${expenseIdx}`, body)
      .then((res) => {
        toast.success("카드 매입내역에 청구 내역 등록되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 매입내역에 은행입출금내역 등록
export const createCardsPurchaseBankTrans = (bankTransIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/cards/purchases/bank-trans/${bankTransIdx}`, body)
      .then((res) => {
        toast.success("카드 매입내역에 입출금 내역 등록되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 매입내역에 거래명세서 등록
export const createPurchaseInvoice = (invoiceIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/cards/purchases/invoices/${invoiceIdx}`, body)
      .then((res) => {
        toast.success("카드 매입내역에 거래명세서가 등록되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 매입내역에서 은행입출금내역 목록삭제
export const deleteCardPurchaseBankTrans = (body) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/cards/purchases/bank-trans`, body)
      .then((res) => {
        toast.success("카드 매입내역에 은행 입출금 내역이 삭제되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 매입내역에서 거래명세서 목록삭제
export const deleteCardPurchaseInvoice = (body) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/cards/purchases/invoices`, body)
      .then((res) => {
        toast.success("카드 매입내역에 거래명세서 목록이 삭제되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 카드 매출 목록
export const getCardsSales = (data) => {
  return new Promise((resolve, reject) => {
    http
      .get("/card-records/sales", { params: data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 카드 매출 목록
export const getCardsSalesDetail = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/card/sales/details")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 카드별 묶음 매출목록
export const getCardsSalesGroup = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/sales/groups/cards", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 매출내역 수정
export const updateCardsSales = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/cards/sales/${idx}`, body)
      .then((res) => {
        toast.success("카드 매출 내역이 수정되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 매출내역에 은행입출금내역 등록
export const createCardSalesBankTrans = (bankTransIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`​/cards​/sales​/bank-trans​/${bankTransIdx}`, body)
      .then((res) => {
        toast.success("카드 매출 내역에 은행입출금 내역이 등록되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 매출내역에 거래명세서 등록
export const createCardSalesInvoice = (invoiceIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`​/cards/sales/invoices/${invoiceIdx}`, body)
      .then((res) => {
        toast.success("카드 매출 내역에 거래명세서가 등록되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 매출내역에서 은행입출금내역 목록삭제
export const deleteCardSalesBankTrans = (body) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/cards/sales/bank-trans`, body)
      .then((res) => {
        toast.success("카드 매출 내역에 은행 입출금 내역이 삭제되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 매출내역에서 거래명세서 목록삭제
export const deleteCardSalesInvoice = (body) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/cards/sales/invoices`, body)
      .then((res) => {
        toast.success("카드 매출 내역에 거래명세서 목록이 삭제되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// ---------------------------카드 api 리뉴얼-------------------------------------
// 신용카드 매출 리스트
export const getCardSalesSummaries = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/sales/summaries", params)
      .then((res) => {
        // toast.success("카드 매출 리스트가 조회되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 요약정보 리스트의 항목을 눌러 펼치는 종속리스트
export const getCardSalesList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/sales/list", params)
      .then((res) => {
        // toast.success("카드 매출 상세가 조회되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매출 상세
export const getCardSalesListDetail = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/sales/list/detail", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매출 지급예정일에 연관 은행 입출금내역 등록
export const createCardSalesItemsBankTrans = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/sales/items/bank-trans", params)
      .then((res) => {
        toast.success("연관 은행 입출금 내역을 등록하였습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매출 지급예정일에 연관 은행 거래명세서 등록
export const createCardSalesItemsInvoice = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/sales/items/invoice", params)
      .then((res) => {
        toast.success("연관 거래명세서 내역을 등록하였습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매출 지급예정일에 연관 데이터 삭제
export const deleteCardSalesItems = (type, cardUseItemIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/card-records/sales/items/${type}/${cardUseItemIdx}`)
      .then((res) => {
        toast.success("연관 항목을 삭제하였습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/* -------------------------------- 매입 -------------------------------- */

// 신용카드 매입 리스트
export const getCardPurchaseSummaries = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/purchase/summaries", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매입 요약정보 리스트의 항목을 눌러 펼치는 종속리스트
export const getCardPurchaseSummariesItems = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/purchase/summaries/items", params)
      .then((res) => {
        // toast.success("카드 매입 상세가 조회되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매입 상세
export const getCardPurchaseSummariesDetail = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/purchase/summaries/detail", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매입 지급예정일에 연관 은행 입출금내역 등록
export const createCardPurchaseItemsBankTrans = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/purchase/items/bank-trans", params)
      .then((res) => {
        toast.success("연관 은행 입출금 내역을 등록하였습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매입 지급예정일에 연관 거래명세서 등록
export const createCardPurchaseItemsInvoice = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/purchase/items/invoice", params)
      .then((res) => {
        toast.success("연관 거래명세서 내역을 등록하였습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매입 결제일에 연관 지출청구건 등록
export const createCardPurchaseItemsExpense = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/purchase/items/expense", params)
      .then((res) => {
        toast.success("연관 지출청구 내역을 등록하였습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매입 결제일에 연관 항목 삭제
export const deleteCardPurchaseItems = (type, cardUseItemIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/card-records/purchase/items/${type}/${cardUseItemIdx}`)
      .then((res) => {
        toast.success("연관 항목을 삭제하였습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매출 건별 상세
export const getCardRecordsSales = (cardSalesIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/card-records/sales/${cardSalesIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매입 건별 상세
export const getCardRecordsPurchase = (cardPurchaseIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/card-records/purchase/${cardPurchaseIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 사용항목 리스트 등록
export const createCardRecordsUseItems = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/card-records/use-items`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 사용항목 리스트 삭제
export const deleteCardRecordsUseItems = (cardUseItemIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/card-records/use-items/${cardUseItemIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매출 엑셀 다운로드
export const getCardSalesSummariesExcel = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/sales/summaries/excel", params, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매출 상세 엑셀 다운로드
export const getCardSalesDetailExcel = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/sales/details/excel", params, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매입 엑셀 다운로드
export const getCardPurchaseSummariesExcel = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/card-records/purchase/summaries/excel", params, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 신용카드 매입 건별 엑셀 다운로드
export const getCardPurchaseAllExcel = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/cards/types/purchase/all/excel", params, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

